/**
 * Events that can be emitted by the course player. Event format: `lua-course-player:<event-name>`.
 * @readonly
 * @example
 * ```typescript
 * document.addEventListener('lua-course-player:sidenav-toggled', (event) => {
 *  console.log('Sidenav toggled', event.detail);
 * });
 * ```
 */
export const CoursePlayerEvents = {
  /** Event emitted when the sidenav is toggled. */
  TOGGLE_SIDENAV: 'lua-course-player:sidenav-toggled',
  /** Event emitted when the user exits the course. */
  EXIT_COURSE: 'lua-course-player:exited',
  BACK_TO_COURSE: 'lua-course-player:navigated-back-to-course',
  NAVIGATE_TO_HOME: 'lua-course-player:navigated-to-home',
  NEXT_COURSE: 'lua-course-player:navigated-to-next-course',
  EDIT_CONTENT: 'lua-course-player:navigated-to-edit-content',
  /** Event emitted when the user navigates to the previous module. */
  PREVIOUS_MODULE: 'lua-course-player:navigated-to-previous-module',
  /* Event emitted when the user navigates to the next module. */
  NEXT_MODULE: 'lua-course-player:navigated-to-next-module',
  GO_TO_MODULE: 'lua-course-player:navigated-to-module',
  /** Event emitted when the course is completed. */
  COURSE_COMPLETED: 'lua-course-player:course-completed',
  /** Event emitted when the user navigates to the content details. */
  CONTENT_DETAILS: 'lua-course-player:navigated-to-content-details',
  /** Event emitted when the user navigates to the description page. */
  SHOW_DESCRIPTION: 'lua-course-player:description-showed',
  DOWNLOAD_CERTIFICATE: 'lua-course-player:certificate-downloaded',
  /** Event emitter to leave Survey / Exam module */
  LEAVE_MODULE: 'lua-course-player:leave-module-clicked',
  SOCIAL_LINK_CLICKED: 'lua-course-player:social-link-clicked',
  SCORM_LAUNCHED: 'lua-course-player:scorm-launched',
  VIEW_BADGES: 'lua-course-player:view-badges',
} as const;

export const SocialMedia = {
  LINKEDIN: 'linkedin',
  TWITTER: 'twitter',
} as const;

export const COURSE_PLAYER_SET_STATE = 'lua-course-player:set-state';

export const COURSE_PLAYER_NAV_OPEN = 'isLuCoursePlayerNavOpen';

export type SocialMedia = (typeof SocialMedia)[keyof typeof SocialMedia];
